import React, { useState } from "react";

const NotificationsTab = ({ updateSpinningWheelTabData,spinningWheelTabData }) => {
    const [isShowPrizeConfirmation, setIsShowPrizeConfirmation] = useState(Number(spinningWheelTabData.is_prize_confirmation_to_client));
    const [isShowOwnerNotification, setIsShowOwnerNotification] = useState(Number(spinningWheelTabData.is_owner_notification));
    const [ownerEmail, setOwnerEmail] = useState(spinningWheelTabData.owner_email);

    //Handle Show Prize Confirmation toggle
    const handleIsShowPrizeConfirmationToggle = (e) => {
        const checked = e.target.checked;
        setIsShowPrizeConfirmation(checked);
        updateSpinningWheelTabData('is_prize_confirmation_to_client', checked);
    };

    //Handle Show Owner Notification toggle
    const handleIsShowOwnerNotificationToggle = (e) => {
        const checked = e.target.checked;
        setIsShowOwnerNotification(checked);
        updateSpinningWheelTabData('is_owner_notification', checked);
    };

    // Handlers Owner Email Change
    const handleOwnerEmailChange = (event) => {
        const value = event.target.value;
        setOwnerEmail(value);
        updateSpinningWheelTabData("owner_email", value);
    };

    return (
         <div className="side-baar-inner-setting">
            <span>Notifications Tab</span>
            <div className="side-baar-box-header">
                <div className="box-header-row">
                    <span>Prize Confirmation to Client</span>
                    <div className="form-group">
                        <input
                            type="checkbox"
                            id="prize_confirmation_toggle"
                            className="chkbx-toggle"
                            checked={isShowPrizeConfirmation}
                            onChange={handleIsShowPrizeConfirmationToggle}
                        />
                        <label htmlFor="prize_confirmation_toggle"></label>
                    </div>
                </div>
            </div>
            <p>Sends a confirmation email to clients with prize information.</p>

            <div className="side-baar-box-header">
                <div className="box-header-row">
                    <span>Owner Notification</span>
                    <div className="form-group">
                        <input
                            type="checkbox"
                            id="owner_notification_toggle"
                            className="chkbx-toggle"
                            checked={isShowOwnerNotification}
                            onChange={handleIsShowOwnerNotificationToggle}
                        />
                        <label htmlFor="owner_notification_toggle"></label>
                    </div>
                </div>
            </div>
            <p>Notifies the business owner by email when a new client submits the form.</p>

            <div className="side-baar-box-header">
                <div className="box-header-row bubble-text">
                    <label>Owner Email</label>
                    <input name="owner_email" value={ownerEmail} onChange={handleOwnerEmailChange}
                    placeholder="Owner Email..." type="text" />
                </div>
            </div>
        </div>
    );
};

export default NotificationsTab;